module.exports = __webpack_public_path__ + "cc9985923e16efbf6b1a243acd34c10b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/mustache-brown.png
// module id = 1820
// module chunks = 0